/**
 * Collection products-per-page. Default page is 72.
 * 48 = ?view=pp48, 24 = ?view=pp24, 72 = no view param.
 */
(function () {
  function currentPp() {
    try {
      var u = new URL(window.location.href);
      var v = (u.searchParams.get('view') || '').toLowerCase();
      if (v === 'pp48' || v === '48') return '48';
      if (v === 'pp24' || v === '24') return '24';
      if (v === 'pp72' || v === '72') return '72';
    } catch (e) {}
    return '72';
  }

  function setPp(v) {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      if (v === '72') u.searchParams.delete('view');
      else if (v === '48') u.searchParams.set('view', 'pp48');
      else if (v === '24') u.searchParams.set('view', 'pp24');
      window.location.href = u.toString();
    } catch (e) {
      window.location.search = v === '72' ? '' : 'view=pp' + v;
    }
  }

  function boot() {
    var sel = document.querySelector('[data-sfl-per-page]');
    if (!sel) return;
    sel.value = currentPp();
    sel.addEventListener('change', function () { setPp(sel.value); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
